@use 'sass:map';
@use 'ui/styles/core-tokens' as core;

.copy {
  &Modal {
    width: 345px;

    &Content {
      display: flex;
      flex-direction: column;
      gap: 24px;
      margin-bottom: 32px;

      &Header {
        display: flex;
        align-items: center;
        gap: 8px;
      }

      .restore {
        align-items: center;
        background-color: map.get(core.$colors, lightGrey);
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        gap: 10px;
        margin-top: 25px;
        padding: 10px 5px;

        &Info {
          display: flex;
          flex-direction: column;
          gap: 10px;
        }
      }
    }

    &Footer {
      justify-content: flex-end;
    }
  }
}

.identities {
  &Modal {
    width: 345px;

    &Footer {
      margin-top: 20px;
    }
  }
}
